import { LoadingIndicator } from '@triumph/design-system';
import { FC, useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import { PdfPreviewProps } from './PdfPreview.types';

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

const PdfPreview: FC<PdfPreviewProps> = ({ url }: PdfPreviewProps) => {
    const [numPages, setNumPages] = useState<number>();

    return (
        <>
            {url && (
                <Document
                    file={url}
                    onLoadSuccess={({ numPages }) => setNumPages(numPages)}
                    loading={<LoadingIndicator show={true} />}
                >
                    {Array.from(new Array(numPages), (_, index) => (
                        <div key={`pdf-preview-${index}`}>
                            <Page
                                pageNumber={index + 1}
                                renderAnnotationLayer={false}
                                renderTextLayer={false}
                                width={550}
                            />
                            <p>
                                Page {index + 1} of {numPages}
                            </p>
                        </div>
                    ))}
                </Document>
            )}
        </>
    );
};

export default PdfPreview;
